<div class="p-4 lg:p-10 flex-1 flex flex-col">
  <div class="hidden md:flex items-center justify-end gap-6">
    <span class="font-efSans-primary"></span>
    <a [href]="viewData.loginUrl">
      <button
        class="revolution ef-branding"
        mat-button
        mat-stroked-button
        color="secondary"
      >
        <a>
          {{ 'register' | sharedTranslate }}
        </a>
      </button>
    </a>
    <!-- <customer-portal-kc-localization-menu class="localizationMenu"></customer-portal-kc-localization-menu> -->
  </div>
  <div class="welcome flex flex-col gap-6 py-6">
    <div class="font-efSans-secondary font-semibold uppercase">
      {{ 'customer-portal' | sharedTranslate }}
    </div>
    <div class="font-canelablack-primary text-4xl md:text-5xl">
      <T
        str="Create your Emil Frey account"
        key="customerPortal.kc.register.title"
        tags="kc-forms, 3.1"
      >
      </T>
    </div>
    <div
      class="text-mat-ef-revolution-primary-500 font-efSans text-xl font-light"
    >
      {{ 'register' | sharedTranslate }}
    </div>
  </div>

  <customer-portal-kc-message></customer-portal-kc-message>

  <form
    class="flex flex-col gap-3 revolution-form"
    #registrationForm
    [formGroup]="form"
    method="POST"
    [action]="viewData.registrationAction"
    (ngSubmit)="register()"
  >
    <div class="w-full lg:w-1/2 py-6 flex flex-col gap-3">
      <mat-form-field class="email">
        <mat-label>
          <T
            str="Email"
            key="customerPortal.kc.register.email"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="alternate_email"></mat-icon>
        <input
          data-cy="registration-email"
          class="input"
          matInput
          required
          formControlName="email"
          name="email"
          [errorStateMatcher]="matcher"
        />
        <mat-icon
          *ngIf="form.controls.email.touched && form.controls.email.invalid"
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-error *ngIf="form.controls.email.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.email,
              'customerPortal.kc.register.email.error.',
              {
                errKey: {
                  pattern: 'enter-valid-email',
                  email: 'enter-valid-email',
                  maxlength: 'maximum-length-exceeded'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="password">
        <mat-label>
          {{ 'password' | sharedTranslate }}
        </mat-label>
        <mat-icon matPrefix svgIcon="vpn"></mat-icon>
        <input
          data-cy="registration-password"
          class="input"
          matInput
          [type]="showPassword ? 'text' : 'password'"
          required
          formControlName="password"
          name="password"
          [errorStateMatcher]="matcher"
        />
        <mat-icon
          *ngIf="
            form.controls.password.touched && form.controls.password.invalid
          "
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-icon
          *ngIf="!showPassword"
          class="togglePasswordIcon"
          matSuffix
          svgIcon="visibility_off"
          (click)="toggleShowPassword()"
        >
        </mat-icon>
        <mat-icon
          *ngIf="showPassword"
          class="togglePasswordIcon"
          matSuffix
          svgIcon="visibility_on"
          (click)="toggleShowPassword()"
        >
        </mat-icon>
        <mat-error *ngIf="form.controls.password.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.password,
              'customerPortal.kc.register.password.error.',
              {
                num: 8,
                errKey: {
                  length: 'min-password-length',
                  minlength: 'min-password-length',
                  lowercase: 'password-lowercase-required',
                  uppercase: 'password-uppercase-required',
                  numeric: 'password-number-required',
                  invalid: 'password-invalid'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
      <mat-form-field class="password-confirm">
        <mat-label>
          <T
            str="Password confirm"
            key="customerPortal.kc.register.password-confirm"
            tags="kc-forms, 3.1"
          >
          </T>
        </mat-label>
        <mat-icon matPrefix svgIcon="vpn"></mat-icon>
        <input
          data-cy="registration-password-confirm"
          class="input"
          matInput
          [type]="showPasswordConfirm ? 'text' : 'password'"
          required
          formControlName="passwordConfirm"
          name="password-confirm"
          [errorStateMatcher]="matcher"
        />
        <mat-icon
          *ngIf="
            form.controls.passwordConfirm.touched &&
            form.controls.passwordConfirm.invalid
          "
          matSuffix
          color="error"
          svgIcon="error_outline"
        ></mat-icon>
        <mat-icon
          *ngIf="!showPasswordConfirm"
          class="togglePasswordIcon"
          matSuffix
          svgIcon="visibility_off"
          (click)="toggleShowPasswordConfirm()"
        >
        </mat-icon>
        <mat-icon
          *ngIf="showPasswordConfirm"
          class="togglePasswordIcon"
          matSuffix
          svgIcon="visibility_on"
          (click)="toggleShowPasswordConfirm()"
        >
        </mat-icon>
        <mat-error *ngIf="form.controls.passwordConfirm.invalid">
          {{
            transifexService.getErrorTranslation(
              form.controls.passwordConfirm,
              'customerPortal.kc.register.password-confirm.error.',
              {
                num: 8,
                errKey: {
                  length: 'min-password-length',
                  minlength: 'min-password-length',
                  lowercase: 'password-lowercase-required',
                  uppercase: 'password-uppercase-required',
                  numeric: 'password-number-required',
                  invalid: 'password-invalid'
                }
              }
            )
          }}
        </mat-error>
      </mat-form-field>
    </div>

    <mat-divider></mat-divider>
    <div class="grid gap-2.5">
      <div class="flex items-center gap-2.5">
        <mat-checkbox
          data-cy="registration-checkbox-1"
          color="primary"
          required
          formControlName="accept"
        ></mat-checkbox>
        <!-- prettier-ignore -->
        <p
          class="a-link font-efSans text-sm text-mat-ef-revolution-primary-500"
          [innerHTML]="getTranslation1()"
        ></p>
      </div>
      <mat-error
        *ngIf="form.controls.accept.dirty && form.controls.accept.invalid"
      >
        <T
          str="You must accept the terms before proceeding"
          key="customerPortal.kc.register.accept.error"
          tags="kc-forms, 3.1"
        >
        </T>
      </mat-error>
      <div class="flex items-center gap-2.5">
        <mat-checkbox
          data-cy="registration-checkbox-2"
          color="primary"
          required
          formControlName="accept2"
        ></mat-checkbox>
        <!-- prettier-ignore -->
        <p
          class="a-link font-efSans text-sm text-mat-ef-revolution-primary-500"
          [innerHTML]="getTranslation2()"
        ></p>
      </div>
      <mat-error
        *ngIf="form.controls.accept2.dirty && form.controls.accept2.invalid"
      >
        <T
          str="You must accept the terms before proceeding"
          key="customerPortal.kc.register.accept.error"
          tags="kc-forms, 3.1"
        >
        </T>
      </mat-error>
    </div>
    <mat-divider></mat-divider>
    <p class="font-efSans-primary my-2.5">
      <T
        str="If you are already an Emil Frey customer, please use the same email address that you gave to our dealership to register."
        key="customerPortal.kc.login.already-ef-customer"
        tags="kc-forms, 3.1"
      >
      </T>
    </p>
    <div class="w-full lg:w-1/2 py-6 flex-1">
      <div class="register-button">
        <button
          data-cy="registration-submit"
          mat-button
          mat-flat-button
          color="secondary"
          type="submit"
          class="w-full py-2 revolution button-spinner"
          (click)="form.patchValue({ action: 'finish' })"
          [disabled]="!form.valid || registering"
        >
          <customer-portal-ef-spinner
            [color]="'mat-ef-revolution-grey-two-500'"
            [opacity]="0.7"
            [diameter]="16"
            *ngIf="registering"
          >
          </customer-portal-ef-spinner>
          <T
            str="Register"
            key="customerPortal.kc.register.button"
            tags="kc-forms, 3.1"
          >
          </T>
        </button>
      </div>
    </div>

    <div
      class="w-full bg-mat-ef-revolution-supergrey-200 rounded-lg p-6 flex flex-col md:flex-row justify-between"
      *ngIf="enableBusiness"
    >
      <span class="font-efSans-primary pl-4 md:pl-0 gap-2 md:gap-0">
        <T
          str="Want to sign up as business?"
          key="customerPortal.kc.register.company-label"
          tags="kc-forms, 3.1"
        >
        </T>
      </span>
      <button
        type="submit"
        class="whitespace-nowrap text-mat-ef-revolution-primary-500 h-9 items-center select-none text-base font-efSans cursor-pointer bg-mat-ef-revolution-supergrey-500 px-4 py-1 rounded-2xl font-semibold"
        (click)="form.patchValue({ action: 'request-business-invite' })"
      >
        <T
          str="Request company account"
          key="customerPortal.kc.company-account.title"
          tags="kc-forms, 3.1"
        >
        </T>
      </button>
    </div>

    <input type="hidden" name="action" [value]="form.value.action" />
  </form>
</div>
